import type { HelpFile } from '../../types/help'
import { AttributeValueInputTestIds } from '../../../testids/AttributeValueInputTestIds'

export const attributeValueInputHelp: HelpFile = {
  docPage: '/docs/admin/attributes',
  texts: {
    [AttributeValueInputTestIds.validationError]:
      'Validation error for the entered attribute value — fix the input before submitting the form.',
    [AttributeValueInputTestIds.validationHint]:
      'Hint describing the expected format or constraints for this attribute value.',
  },
}
